export default {
  tab: {
    _3_months: '3 Tháng',
    _6_months: '6 Tháng',
    _9_months: '9 Tháng',
    this_year: '1 Năm',
    three_years: '3 Năm',
    all_time: 'Tất Cả',
  },
  chartTitle: 'BIỂU ĐỔ ĐỊNH GIÁ',
  avgPlus1Std: 'Trung bình giá trị cộng 1 lần độ lệch chuẩn',
  avgPlus2Std: 'Trung bình giá trị cộng 2 lần độ lệch chuẩn',
  avgSub1Std: 'Trung bình giá trị trừ 1 lần độ lệch chuẩn',
  avgSub2Std: 'Trung bình giá trị trừ 2 lần độ lệch chuẩn',
  footer: 'Giá: x 1,000.',
};
